import React, { useState } from "react";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Sheet from "@mui/joy/Sheet";
import { useAuth } from "../../../../utils/useAuth";
import { useNavigate } from "react-router";
import toast from "react-hot-toast";
import sslLogo from "../../../../assets/paymentMethod/ssl.png";
import banglaqrLogo from "../../../../assets/paymentMethod/banglaqr.png";
import sslPay from "../../../../assets/paymentMethod/sslpay.png";
import QR from "../../../../assets/paymentMethod/qr.jpeg";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { RiSecurePaymentFill } from "react-icons/ri";
import { createTourBooking } from "../../../../api/website/booking/tour/tourBookingAPI";

const PaymentMethod = ({
  open,
  setOpen,
  setFormData,
  FormData,
  bookedBy,
  setError,
  setIsProcessing,
}) => {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();
  const [ShowQR, setShowQR] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const generateBookingId = () =>
    Math.random().toString(36).substring(2, 10).toUpperCase();
  const handlePayNow = async () => {
    if (FormData.paymentMethod === 2) {
      setShowQR(true);
      setFormData((prev) => ({
        ...prev,
        transactionId: "",
      }));
    } else {
    }
  };
  const handleBanglaQR = () => {
    if (FormData.transactionId === "") {
      toast.error("Transaction ID Required");
    } else {
      createTourBooking(FormData, bookedBy, setIsLoading, navigate);
    }
  };
  return (
    <>
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => setOpen(false)}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{
            minWidth: {
              xs: 320, // Mobile
              sm: 400, // Small tablets
              md: 500, // Desktop
            },
            borderRadius: "md",
            p: 3,
            boxShadow: "lg",
          }}
        >
          <ModalClose variant="plain" sx={{ m: 1 }} />
          <p className="font-bold uppercase">Payment Method</p>
          {ShowQR ? (
            <div className="space-y-3 mt-3">
              <div>
                <img className="w-full h-60 object-contain" src={QR} alt="" />
              </div>
              <div>
                <label className="text-xs lg:text-sm" htmlFor="">
                  Transaction Id <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={FormData.transactionId}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      transactionId: e.target.value,
                    }))
                  }
                  className="p-1 lg:p-2 rounded-md border w-full focus:outline-none"
                  placeholder="Transaction ID"
                />
              </div>
              <div className="space-y-2">
                <p className="text-xs lg:text-sm font-medium uppercase">
                  Instructions:
                </p>
                <p className="text-[9px] lg:text-[10px]">
                  1. Scan with any payment app including MFS (Mobile Financing
                  Service) and Banking app.
                </p>
                <p className="text-[9px] lg:text-[10px]">
                  2. If you're payment is successfully paid, then add your
                  transaction ID above input box.
                </p>
                <p className="text-[9px] lg:text-[10px]">
                  3. And submit to checkout. If anything happened, please
                  contact our support for any help.
                </p>
              </div>
              <div>
                <button
                  onClick={handleBanglaQR}
                  className="bg-[#161f52] w-full hover:bg-[#0a0e25] duration-300 text-white font-medium py-2 px-4 rounded"
                  disabled={IsLoading ? true : false}
                >
                  {IsLoading ? "Processing, wait!" : " Check out now!"}
                </button>
              </div>
            </div>
          ) : (
            <div className="space-y-5 mt-5">
              <div className="flex justify-center items-center gap-5 lg:gap-10 p-2 ">
                {/* <div className="flex flex-col gap-y-1">
                  <div
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        paymentMethod: prev.paymentMethod === 1 ? 0 : 1,
                      }))
                    }
                    className={`relative w-28 lg:w-40 h-28 lg:h-40 border ${FormData.paymentMethod === 1 ? "border-green-500 border-0.5" : ""} rounded-lg p-2 cursor-pointer`}
                  >
                    <img
                      className="w-full h-full object-contain"
                      src={sslLogo}
                      alt=""
                    />
                    {FormData.paymentMethod === 1 && (
                      <div className="absolute -top-2 -right-3 bg-white rounded-full">
                        <IoIosCheckmarkCircle className="text-2xl text-green-700" />
                      </div>
                    )}
                  </div>
                  <div className="flex justify-start items-center gap-1">
                    <RiSecurePaymentFill className="text-sm lg:text-md text-blue-700 " />
                    <p className="text-[10px] lg:text-xs">Use SSL Commerz</p>
                  </div>
                </div> */}
                <div className="flex flex-col gap-y-1">
                  <div
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        paymentMethod: prev.paymentMethod === 2 ? 0 : 2,
                      }))
                    }
                    className={`relative w-28 lg:w-40 h-28 lg:h-40 border ${FormData.paymentMethod === 2 ? "border-green-500 border-0.5" : ""} rounded-lg p-2 cursor-pointer`}
                  >
                    <img
                      className="w-full h-full object-contain"
                      src={banglaqrLogo}
                      alt=""
                    />
                    {FormData.paymentMethod === 2 && (
                      <div className="absolute -top-2 -right-3 bg-white rounded-full">
                        <IoIosCheckmarkCircle className="text-2xl text-green-700" />
                      </div>
                    )}
                  </div>
                  <div className="flex justify-start items-center gap-1">
                    <RiSecurePaymentFill className="text-sm lg:text-md  text-blue-700 " />
                    <p className="text-[10px] lg:text-xs">Use Bangla QR</p>
                  </div>
                </div>
              </div>

              <div>
                <button
                  onClick={handlePayNow}
                  className="bg-[#161f52] w-full hover:bg-[#0a0e25] duration-300 text-white font-bold py-2 px-4 rounded"
                >
                  Pay Now {FormData.totalAmount || 0} BDT
                </button>
              </div>
            </div>
          )}
        </Sheet>
      </Modal>
    </>
  );
};

export default PaymentMethod;
